import { logger } from '@automata/utils';

import {
  LATEST_WORKFLOW_MIGRATION_VERSION,
  LoadedWorkflowLatest,
  _MIGRATION_CHAIN,
} from './chain';
import { _migrateTo1 } from './migrateTo1';
import { runMigrationChain } from './runMigrationChain';

type Layout = {
  version: string;
  data: any;
};

export const _migrateLoadedVisualBuilderData = (
  workflowConfig: any
): LoadedWorkflowLatest => {
  const layout = workflowConfig?.workflow?.layout as Layout | undefined;

  // Before version '1', the `version` value was left as an empty string '', so we'll call that zero
  let version: number;
  let layoutData;

  if (!layout || layout.version === '') {
    version = 0;
  } else {
    version = Number(layout.version);
    if (Number.isNaN(version) || !Number.isInteger(version) || version < 0) {
      throw new Error(
        `Invalid workflow layout version: ${layout.version} (parsed as ${version})`
      );
    }
  }

  logger.log(
    `Migration: loading version ${version}, latest is ${LATEST_WORKFLOW_MIGRATION_VERSION}`
  );

  if (version === 0) {
    // We don't want the migration chain to include workflow config data, only "layout" data.
    // But the initial v0 stored limited data in "layout" and stored other required data elsewhere in
    // the workflow config, so we need to make a special exception for v0->v1 and give it
    // the whole workflow config.
    layoutData = _migrateTo1(workflowConfig);

    version = 1;
  } else {
    layoutData = layout ? layout.data : {};
  }

  return runMigrationChain({
    version,
    data: layoutData,
    migrationChain: _MIGRATION_CHAIN,
  });
};
